// Central route map so Nav/Footer links and <Route> paths never drift apart.
export const PATHS = {
  home: '/',
  privacy: '/privacy',
  licensing: '/licensing',
  ccpp: '/ccpp',
  security: '/security',
  terms: '/terms',
  dataPartners: '/data-partners',
  optOut: '/opt-out',
  businessProfiles: '/business-profiles',
};

export const LEGAL_LINKS = [
  { label: 'Privacy Policy', path: PATHS.privacy },
  { label: 'Legal & Licensing', path: PATHS.licensing },
  { label: 'CCPA', path: PATHS.ccpp },
  { label: 'Security Statement', path: PATHS.security },
  { label: 'Terms of Use', path: PATHS.terms },
  { label: 'Data Partners', path: PATHS.dataPartners },
  { label: 'Opt-Out', path: PATHS.optOut },
  { label: 'Business Profiles', path: PATHS.businessProfiles },
];
